import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const forAreaRugs = (Component) => () => {
  const {
    segment,
  } = useContext(ExperienceContext);

  if (segment !== 'area-rugs') return null;
  return <Component />;
};